import * as themes from "@memento/compilation-themes/DO_NOT_IMPORT";
export const sampleThemes = Object.values(themes);
